<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'branch/index' }">
                                Cabang
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Detail Cabang
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-auto" v-if="roleElligible()">
                <button v-on:click="modal.download = true" class="btn btn-danger btn-sm font-weight-medium mt-4 mb-2 px-5 mr-2">
                    Download Kehadiran Siswa
                </button>
                <button v-if="profile.isAdmin" v-on:click="confirmation(branch, true)" class="btn btn-outline-danger btn-sm font-weight-medium mt-4 mb-2 px-5">
                    Delete Cabang
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Profil Cabang
                                </span>
                            </div>
                            <div class="col-auto" v-if="profile.isAdmin">
                                <router-link v-bind:to="{ name: 'branch/edit', params: {id: branch.id} }" class="btn btn-link h4 p-0 m-0">
                                    Edit
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <div class="card-title text-muted">
                            Logo Cabang:
                        </div>
                        <img v-bind:src="branch.imageUrl" class="img-fluid mb-3" />
                        <div class="text-muted">
                            Nama Cabang:
                        </div>
                        <div class="text-loading">{{ branch.name }}</div>
                        <div class="text-muted">
                            Alamat Cabang:
                        </div>
                        <div class="text-loading">{{ branch.address }}</div>
                        <div class="text-muted">
                            Jenis Cabang:
                        </div>
                        <div v-if="Object.keys(branch).length" class="text-loading">Cabang {{ branch.isPrimary ? 'Utama' : 'Mitra' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12" v-for="(program, index) in branch.branchPrograms" v-bind:key="program.id">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0 text-loading">{{ program.grade.name }} {{ program.programType.name }}</span>
                            </div>
                            <div class="col-auto" v-if="profile.isAdmin">
                                <router-link v-bind:to="{ name: 'branch/program/edit', params: {id: branch.id, programID: program.id} }" class="btn btn-link h4 p-0 my-0 mr-2">
                                    Edit
                                </router-link>
                                <button v-on:click="confirmation(program, false)" class="btn btn-link h4 p-0 my-0">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <div class="row">
                                    <div class="col-4 col-lg-6 col-xl-4">
                                        <h4 class="text-muted mb-1">
                                            Program
                                        </h4>
                                    </div>
                                    <div class="col-8 col-lg-6 col-xl-8">
                                        <h4 class="text-muted mb-1">
                                            Tipe Kelas:
                                        </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4 col-lg-6 col-xl-4">
                                        <h4 class="font-weight-bold mb-1">
                                            {{ program.grade.name }}
                                        </h4>
                                    </div>
                                    <div class="col-8 col-lg-6 col-xl-8">
                                        <h4 class="font-weight-bold mb-1">
                                            {{ program.programType.name }}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mb-2" v-for="(pattern, index) in program.patterns" v-bind:key="pattern.id">
                                <router-link v-bind:to="{ name: 'branch/program/pattern/view', params: {id: branch.id, programID: program.id, patternID: pattern.id} }" class="h4 text-danger font-weight-bold mb-1">
                                    Pola {{ index + 1 }}
                                </router-link>
                                <div class="row">
                                    <div class="col-4 col-lg-6 col-xl-4">
                                        <h4 class="text-muted mb-1">
                                            Hari Pola
                                        </h4>
                                    </div>
                                    <div class="col-8 col-lg-6 col-xl-8">
                                        <h4 class="text-muted mb-1">
                                            Sesi Pola:
                                        </h4>
                                    </div>
                                </div>
                                <div class="row" v-for="period in pattern.periods" v-bind:key="period.id">
                                    <div class="col-4 col-lg-6 col-xl-4">
                                        <h4 class="font-weight-bold mb-1">
                                            {{ $moment.weekdays(period.day) }}
                                        </h4>
                                    </div>
                                    <div class="col-8 col-lg-6 col-xl-8">
                                        <h4 class="font-weight-bold mb-1">
                                            {{ [period.start, "HH:mm:ss"] | moment("HH.mm") }} - {{ [period.end, "HH:mm:ss"] | moment("HH.mm") }} ({{ period.slots }})
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mb-2" v-for="(intensive, index) in program.intensiveSchedules" v-bind:key="intensive.id">
                                <router-link v-bind:to="{ name: 'branch/program/intensive/view', params: {id: branch.id, programID: program.id, intensiveID: intensive.id} }" class="h4 text-danger font-weight-bold mb-1">
                                    {{ intensive.name }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-1" v-if="branch.isPrimary && profile.isAdmin">
            <div class="col">
                <router-link v-bind:to="{ name: 'branch/program/add', params: {id: branch.id} }" class="btn btn-danger btn-sm font-weight-medium px-4">
                    Create Program Cabang +
                </router-link>
            </div>
        </div>
        <b-modal v-model="modal.remove" v-on:hide="removeReference = null; isBranchReference = false" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="profile.isAdmin">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus {{ isBranchReference ? 'cabang' : 'program' }} ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove = false">
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modal.download" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligible()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Download Kehadiran Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="download()">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="row mb-1 align-items-center">
                                <div class="col-12 px-1">
                                    <label class="font-weight-medium text-muted h4">Interval</label>
                                </div>
                                <div class="col-lg-6 px-1 mb-2">
                                    <datepicker v-model="form.start" v-bind:language="dateLanguage" full-month-name monday-first clear-button input-class="form-control form-control-sm"></datepicker>
                                </div>
                                <div class="col-lg-6 px-1 mb-2">
                                    <datepicker v-model="form.end" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{to: form.start}" input-class="form-control form-control-sm"></datepicker>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-12 px-1">
                                    <label class="font-weight-medium text-muted h4">Semester</label>
                                </div>
                                <div class="col-lg-12 px-1 mb-2">
                                    <select v-model="form.semester" class="form-control form-control-sm">
                                        <option v-for="semester in semesters" v-bind:value="semester.id" v-bind:key="semester.id">{{ semester.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center mb-3">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.download = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { id } from 'vuejs-datepicker/dist/locale';
    import { semesters } from '@/params.js';
    import qs from 'qs';
    import Datepicker from 'vuejs-datepicker';

    /**
     * @param {Object} branch
     * @param {Integer} branch.id
     * @param {String} branch.name
     * @param {String} branch.address
     * @param {String} branch.image
     * @param {String} branch.imageUrl
     * @param {Boolean} branch.isPrimary
     */
    export default {
        name: "BranchView",
        components: {
            Datepicker
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            'form.start'(start) {
                if (start) {
                    if (!this.form.end || this.$moment(start).isAfter(this.$moment(this.form.end))) {
                        this.form.end = start;
                    }
                }
            }
        },
        data() {
            return {
                form: {
                    start: this.$moment().startOf('year').toDate(),
                    end: this.$moment().toDate(),
                    semester: 1
                },
                branch: {},
                isBranchReference: false,
                removeReference: null,
                dateLanguage: id,
                semesters: semesters,
                modal: {
                    remove: false,
                    download: false
                }
            };
        },
        methods: {
            confirmation(model, isBranchReference) {
                this.isBranchReference = isBranchReference;
                this.modal.remove = true;
                this.removeReference = model;
            },
            remove() {
                if (this.removeReference) {
                    var url = this.isBranchReference ? process.env.API_URL + '/branch/delete/' + this.removeReference.id : process.env.API_URL + '/branch-program/delete/' + this.removeReference.id;
                    this.axios.post(url).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            if (this.isBranchReference) {
                                this.$router.push({name: 'branch/index'});
                            } else {
                                this.fetchBanner();
                            }
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modal.remove = false;
                        this.isBranchReference = false;
                        this.removeReference = null;
                    });
                }
            },
            download() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                for (var attribute in this.form) {
                    var value = this.form[attribute];
                    if (value instanceof Date) {
                        this.form[attribute] = this.$moment(value).format('YYYY-MM-DD');
                    }
                }
                window.location = process.env.API_URL + '/attendance/download-student-attendance?' + qs.stringify(Object.assign({}, {token: token, branchID: this.branch.id, termID: this.term.id}, this.form), {encode: false});
                this.modal.download = false;
            },
            fetchBanner() {
                this.axios.get(process.env.API_URL + '/branch/' + this.$route.params.id).then(response => {
                    this.branch = response.data.data;

                    document.title = this.branch.name + ' - ' + process.env.APP_NAME;
                }).catch((error) => {
                    this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
                });
            },
            roleElligible() {
                return this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee.isBranchStaff);
            }
        },
        created() {
            this.fetchBanner();
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/branch/View.vue